// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Nunito_Sans_6e9594', '__Nunito_Sans_Fallback_6e9594'","fontStyle":"normal"},"className":"__className_6e9594"};